<template>
  <footer class="footer" style="background-image: url('/imgs/start/images/footer-bg_02.png');">
    <div class="footer-container">
      <!-- Logo Area -->
      <div class="footer-logo">
        <img src="/imgs/start/images/footer-logo_05.png" alt="AIT Logo">
      </div>
      
      <!-- Main Footer Content -->
      <div class="footer-main">
        <!-- Contact Information -->
        <div class="contact-section">
          <div class="contact-item">
            <img src="/imgs/start/images/icon-phone_03.png" alt="">
            <span>+86 532 81838877</span>
          </div>
          <div class="contact-item">
            <img src="/imgs/start/images/icon-chuanzhenji_03.png" alt="">
            <span>+86 532 85829167</span>
          </div>
          <div class="contact-item">
            <img src="/imgs/start/images/icon-email_06.png" alt="">
            <span>LEI.AN@ALPACA.CN</span>
          </div>
          <div class="contact-item">
            <img src="/imgs/start/images/icon-dizhi_09.png" alt="">
            <span>山东省青岛市市南区山东路9号深业大厦B-14H</span>
          </div>
        </div>
        
        <!-- Links Sections -->
        <div class="links-section">
          <div class="link-group">
            <h3 class="clickable-title" @click="navigateTo('/company')">走进企业</h3>
            <ul>
              <li><a href="#" @click.prevent="navigateTo('/company', 'section1')">公司简介</a></li>
              <li><a href="#" @click.prevent="navigateTo('/company', 'section2')">主营业务</a></li>
              <li><a href="#" @click.prevent="navigateTo('/company', 'section3')">发展历程</a></li>
              <li><a href="#" @click.prevent="navigateTo('/company', 'section4')">企业宗旨</a></li>
              <li><a href="#" @click.prevent="navigateTo('/company', 'section5')">荣誉资质</a></li>
            </ul>
          </div>
          
          <div class="link-group">
            <h3 class="clickable-title" @click="navigateTo('/product')">匠心产品</h3>
            <ul>
              <li><a href="#" @click.prevent="navigateTo('/product', 'section1')">产品介绍</a></li>
              <li><a href="#" @click.prevent="navigateTo('/product', 'section2')">加工工艺</a></li>
              <li><a href="#" @click.prevent="navigateTo('/product', 'section3')">为什么选择羊驼毛</a></li>
            </ul>
          </div>
          
          <div class="link-group">
            <h3 class="clickable-title" @click="navigateTo('/field')">应用领域</h3>
          </div>
          
          <div class="link-group">
            <h3 class="clickable-title" @click="navigateTo('/about')">关于羊驼</h3>
            <ul>
              <li><a href="#" @click.prevent="navigateTo('/about', 'section1')">南美驼科品种</a></li>
              <li><a href="#" @click.prevent="navigateTo('/about', 'section2')">羊驼毛规格</a></li>
            </ul>
          </div>
          
          <div class="link-group">
            <h3 class="clickable-title" @click="navigateTo('/contact')">联系我们</h3>
            <ul>
              <li><a href="#" @click.prevent="navigateTo('/contact', 'section1')">联系我们</a></li>
              <li><a href="#" @click.prevent="navigateTo('/contact', 'section2')">在线留言</a></li>
            </ul>
          </div>
        </div>
        
        <!-- QR Code -->
        <div class="qrcode-section">
          <img src="/imgs/start/images/erweima_03.png" alt="微信公众号二维码">
          <p>关注公众号，了解更多</p>
        </div>
      </div>
      
      <!-- Footer Bottom -->
      <div class="footer-bottom">
        <div class="copyright">
          Copyright ©2025 青岛阿尔帕卡特种纤维国际贸易有限公司 All Rights Reserved
        </div>
        <div class="legal-links">
          <a href="#">网站建设  |  东八区创意</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterView',
  methods: {
    // 导航跳转方法
    navigateTo(route, sectionId) {
      if (!route) return;
      // 若已在目标路由，直接返回，避免重复 push
      if (this.$route.path === route) {
        // 如果已经在目标路由且有sectionId，直接滚动到对应section
        if (sectionId) {
          this.scrollToSection(sectionId);
        }
        return;
      }
      // 跳转到目标路由
      this.$router.push(route).then(() => {
        // 路由跳转成功后，如果有sectionId则滚动到对应section
        if (sectionId) {
          // 使用nextTick确保DOM已更新，然后增加额外延迟等待页面完全渲染
          this.$nextTick(() => {
            setTimeout(() => {
              this.scrollToSection(sectionId);
            }, 300);
          });
        }
      }).catch(() => {});
    },
    // 滚动到指定section（带重试机制）
    scrollToSection(sectionId, retryCount = 0) {
      const section = document.getElementById(sectionId);
      if (section) {
        const offsetTop = section.offsetTop - 80; // 减去header高度
        window.scrollTo({
          top: offsetTop,
          behavior: "smooth",
        });
      } else if (retryCount < 5) {
        // 如果找不到section，重试最多5次，每次间隔200ms
        setTimeout(() => {
          this.scrollToSection(sectionId, retryCount + 1);
        }, 200);
      }
    }
  }
}
</script>

<style scoped>
.footer {
  min-height: 400px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: #ffffff;
  padding: 40px 0;
  border-radius: 40px 40px 0 0;
}

@media (max-width: 768px) {
  .footer {
    display: none;
  }
}

.footer-container {
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-logo {
  text-align: left;
  margin-bottom: 30px;
  border-bottom: 2px solid rgba(255, 255, 255, 1);
  padding: 0 50px 20px 50px;
}

.footer-logo img {
  display: inline-block;
  height: auto;
}

.footer-main {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  flex-wrap: wrap;
  padding: 0 50px;

}

.contact-section {
  flex: 1;
  min-width: 250px;
  margin-right: 40px;
}

.contact-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  font-size: 18px;
  letter-spacing: 2px;
}

.contact-item img {
  margin-right: 30px;
}

.contact-item i {
  width: 20px;
  margin-right: 10px;
  text-align: center;
}

.links-section {
    font-family: 'Source_Han_Sans_SC_Normal';
  display: flex;
  flex: 1.5;
  /* justify-content: space-between; */
  justify-content: space-evenly;

  min-width: 500px;
}

.link-group {
  margin-right: 30px;
}

.link-group h3 {
  font-size: 18px;
  margin-bottom: 15px;
  font-weight: bold;
  cursor: pointer;
}

.link-group ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.link-group ul li {
  margin-bottom: 8px;
}

.link-group ul li a {
  color: #ffffff;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s;
}

.link-group ul li a:hover {
  color: #f0f0f0;
}

.qrcode-section {
  text-align: center;
  min-width: 120px;
}

.qrcode-section img {
  width: 100px;
  height: 100px;
  margin-bottom: 10px;
}

.qrcode-section p {
  font-size: 12px;
  margin: 0;
}

.footer-bottom {
  /* border-top: 1px solid rgba(255, 255, 255, 0.3); */
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
  font-size: 15px;
  padding: 0 50px;
}

.legal-links a {
  color: #ffffff;
  text-decoration: none;
}

.legal-links a:hover {
  text-decoration: underline;
}

/* Responsive Design */
@media (max-width: 768px) {
  .footer-main {
    flex-direction: column;
    text-align: center;
  }
  
  .contact-section,
  .links-section,
  .qrcode-section {
    margin-right: 0;
    margin-bottom: 30px;
    min-width: 100%;
  }
  
  .links-section {
    flex-direction: column;
    align-items: center;
  }
  
  .link-group {
    margin-right: 0;
    margin-bottom: 20px;
  }
  
  .footer-bottom {
    flex-direction: column;
    text-align: center;
  }
}
</style>